import { useLayoutEffect, useState } from "react";

import type { PageSize } from "./fitZoom";

const SCROLLING_OVERFLOW = new Set(["auto", "scroll", "overlay"]);

/** The nearest element, from `start` up, that scrolls its content vertically; null for the window. */
export function scrollingAncestor(start: HTMLElement | null): HTMLElement | null {
  for (let element = start; element != null; element = element.parentElement) {
    if (
      element.scrollHeight > element.clientHeight &&
      SCROLLING_OVERFLOW.has(getComputedStyle(element).overflowY)
    ) {
      return element;
    }
  }
  return null;
}

/**
 * What clips the pages as the reader scrolls: the viewport when it scrolls, else
 * the nearest scrolling ancestor or the window. Re-read whenever the pages resize.
 */
export function usePageClip(
  viewport: HTMLElement | null,
  pageSizes: readonly PageSize[] | null,
  zoom: number
): HTMLElement | null {
  const [clip, setClip] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => {
    setClip(scrollingAncestor(viewport));
  }, [viewport, pageSizes, zoom]);
  return clip;
}
